import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';
import * as getters from './getters';

const initialState = {
  list: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  detail: { data: null, loading: false },
  thumb: { data: null, loading: false },
  jointPage: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  slotMaterials: { data: [], loading: false },
  componentTypes: { data: [], loading: false },
  axialTypes: { data: [], loading: false },
  illuminantTypes: { data: [], loading: false },
  priceDialog: { visible: false, loading: false, data: null },
  ueDialog: { visible: false, loading: false, fullpath: '' },
  confirm: { title: '', content: '', name: '', visible: false, loading: false },
  searchParams: null,
  loading: false,

  modelInfo: { data: null, loading: false },
};

export default { namespaced: true, state: initialState, actions, mutations, getters } as IStore<IModuleState>;
